import { Component, inject } from '@angular/core';
import { ButtonWarehouseComponent } from '../../components/returns-portal-components/button-warehouse/button-warehouse.component';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/core/services/translate/localstorage.service';
import { TranslateService } from 'src/app/core/services/translate/translate.service';
import { Location } from '@angular/common';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
	selector: 'app-page404',
	standalone: true,
	imports: [
		ButtonWarehouseComponent,
		TranslatePipe
	],
	templateUrl: './page404.component.html',
	styleUrl: './page404.component.scss'
})
export class Page404Component {
	public router = inject( Router );
	public localService = inject( LocalStorageService );
	public ts = inject( TranslateService );
	public location = inject( Location );

	goBack(): void {
		this.location.back();
	}
	tryToLogin(){
		this.router.navigateByUrl('auth/login')
	}
}
